import styles from "@/styles/login-layout.module.scss"
import React from "react"
import { useEffect } from "react"

import { loadMatomo } from "@/utils/matomo"
import { loadGtm } from "@/utils/gtm"

import Image from 'next/image'
import Link from 'next/link'
import GoogleAnalytics from "./GoogleAnalytics"
import { setCookie } from "@/utils/cookie"
import { useRouter } from "next/router"

interface LayoutProps {
  children: React.ReactNode;
  wideScreen?: boolean;  // 是否使用宽屏
  notStickyNavbar?: boolean; // 是否取消Navbar吸顶效果
}

export default function LoginLayout(props: LayoutProps) {
  useEffect(() => {
    // 创建字体链接
    const loadFonts = () => {
      const fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = 'https://fonts.googleapis.com/css?family=Rubik:300,400,500,700,900&display=swap';
      
      // 添加预连接优化
      const preconnectLink = document.createElement('link');
      preconnectLink.rel = 'preconnect';
      preconnectLink.href = 'https://fonts.gstatic.com';
      preconnectLink.crossOrigin = 'anonymous';
      
      document.head.appendChild(preconnectLink);
      document.head.appendChild(fontLink);
    };

    // 动态创建广告脚本
    const loadAdScript = () => {
      const adsbygoogleScript = document.createElement('script');
      adsbygoogleScript.async = true;
      adsbygoogleScript.src = "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      document.body.appendChild(adsbygoogleScript);
    };

    // 动态创建Criteo脚本
    const loadCriteoScript = () => {
      const criteoScript = document.createElement('script');
      criteoScript.async = true;
      criteoScript.src = "https://static.criteo.net/js/ld/ld.js";
      document.body.appendChild(criteoScript);
    };

    function handleWindowLoad() {
      loadFonts();
      loadAdScript();
      loadCriteoScript();
      loadMatomo()
      loadGtm();
    }
    
    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

    const router = useRouter()
  
  useEffect(() => {
    const { aid, recoveraid }: any = router.query
    let lastAidValue = ''
    let lastRecoveraidValue = ''
  
    // 检查是否有"aid"参数，如有多个取最后
    if (Array.isArray(aid) && aid.length > 0) {
      lastAidValue = aid[aid.length - 1]
    } else if (typeof aid === 'string') {
      // 如果只有一个"aid"参数，它将是一个字符串
      lastAidValue = aid
    }
  
    // 检查是否有"recoveraid"参数，如有多个取最后
    if (Array.isArray(recoveraid) && recoveraid.length > 0) {
      lastRecoveraidValue = recoveraid[recoveraid.length - 1]
    } else if (typeof recoveraid === 'string') {
      // 如果只有一个"recoveraid"参数，它将是一个字符串
      lastRecoveraidValue = recoveraid
    }
  
    // 优先于异步请求，将aid存入cookie, 60秒过期（后续会发起请求重新设置）
    if (lastAidValue || lastRecoveraidValue) {
      let currentDomain = window.location.hostname;
      if (currentDomain == 'www.crazysales.com.au') {
        currentDomain = ".crazysales.com.au"
      }
      setCookie('affiliateid', lastAidValue || lastRecoveraidValue, { expires: 30, secure: true, domain: `${currentDomain}`, })
    }
  }, [router.query])

  return (
    <div className={styles['login-layout']}>
      <GoogleAnalytics />
      <div className={styles['header']}>
        <Link
          href='/'
          legacyBehavior
        >
          <a rel="noopener noreferrer">
            <Image
              className={styles['site-logo']}
              alt="logo"
              priority={true}
              width={246}
              height={70}
              src="//static.crazysales.com.au/images/2022v/img/logo.svg" />
          </a>
        </Link>
      </div>

      <main style={{ background: '#F5F5F5', minHeight: 'calc(100vh - 200px)' }}>{props.children}</main>

      <div className={styles['footer']}>
        <Link
          href='/review-conditions'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            Terms & Conditions
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/article/PrivacyStatement'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            Privacy Statement
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            <Image
              className={styles['site-logo']}
              alt="logo"
              priority={true}
              width={112}
              height={27}
              src="https://img.crazysales.com.au/images/easy-layout-Norton.png" />
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/'
          legacyBehavior
        >
          <Image
            className={styles['site-logo']}
            alt="logo"
            priority={true}
            width={88}
            height={47}
            src="https://img.crazysales.com.au/images/easy-layout-comodo.png" />
        </Link>
      </div>
    </div>
  )
}